'use strict';
import * as T from 'prop-types';
import React from 'react';
import {ButtonState, isButtonState} from '../../../core-utilities/enums/ButtonState';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {Button} from '../../buttons/Button';
import {StatefulButton} from '../../buttons/StatefulButton';
import {Modal} from '../Modal';
import {ModalContent} from '../ModalContent';
import {ModalFooter} from '../ModalFooter';
import {ModalHeader} from '../ModalHeader';


export function BaseFormModalView(props) {
  return (
    <Modal className={props.className}>
      <ModalHeader modalHeaderLabel={props.modalHeaderLabel} />
      <ModalContent>
        {props.children}
      </ModalContent>
      <ModalFooter>
        <Button
          className="FormModal__cancelButton"
          disabled={props.mode !== ButtonState.START}
          label={props.cancelLabel}
          onClick={props.onCancel}
        />
        <StatefulButton
          buttonClassName="FormModal__saveButton"
          startClassName="FormModal__saveButton_start"
          frontClassName="FormModal__saveButton_content"
          backClassName="FormModal__saveButton_content"
          workingIconClassName="FormModal__saveButton_icon"
          startLabel={props.createLabel}
          usePropState={true}
          mode={props.mode}
          onClick={props.onTriggerSave}
        />
      </ModalFooter>
    </Modal>
  );
}

BaseFormModalView.propTypes = {
  className: T.string,
  mode: isButtonState,

  onCancel: T.func,
  onTriggerSave: T.func,

  cancelLabel: T.string,
  createLabel: T.string,
  modalHeaderLabel: T.string,
};

export const FormModalView = I18nComponent(BaseFormModalView, [
  {code: 'default.button.cancel.label', prop: 'cancelLabel'},
  {code: 'default.button.save.label', prop: 'createLabel'},
  {prop: 'modalHeaderLabel', dynamic: getHeaderCode},
]);

function getHeaderCode(props) {
  return {
    code: props.modalHeaderLabel,
  };
}



// WEBPACK FOOTER //
// ./src/js/components/modals/FormModal/FormModalView.js